<app-expansion-panel i18n-title title="Facturation">
  <div class="flow-invoices">
    <div class="flow-invoices-header">
      <div class="lty-input-icon-group search-bar">
        <input
          class="form-control lty-form-control"
          placeholder="Rechercher"
          i18n-placeholder
          [formControl]="searchControl"
        />
        <div class="input-icon">
          <app-search-icon height="20px" width="20px" color="var(--gray-500)" />
        </div>
      </div>

      <div class="flow-invoices-filters">
        <div class="flow-invoice-filter flow-invoice-filter-insurer">
          <app-combobox
            [control]="insurerFilter"
            [items]="insurerSearchResults()"
            placeholder="Assureur"
            i18n-placeholder
            [itemTemplate]="insurerTpl"
            (searchChange)="onInsurerSearch($event)"
          />
        </div>
        <ng-template #insurerTpl let-insurer>{{ insurer.name }}</ng-template>

        <div class="flow-invoice-filter flow-invoice-filter-status">
          <app-bill-state-combobox
            [control]="statusFilter"
            [states]="statusFilterStates"
            [noBorder]="true"
            [enableUnselect]="true"
            placeholder="Statut"
            i18n-placeholder
          />
        </div>

        <div
          class="flow-invoice-filter flow-invoice-filter-period"
          [class.is-empty]="isPeriodEmpty"
          i18n-title
          title="Période de facturation"
        >
          <mat-form-field appearance="fill">
            <mat-date-range-input
              [rangePicker]="periodPicker"
              [formGroup]="periodRange"
            >
              <input
                matStartDate
                formControlName="start"
                placeholder="Période de facturation"
                i18n-placeholder
              />
              <input
                matEndDate
                formControlName="end"
                placeholder="Au"
                i18n-placeholder
                (dateChange)="onPeriodChange()"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="periodPicker" />
            <mat-date-range-picker #periodPicker />
          </mat-form-field>
          @if (!isPeriodEmpty) {
            <button
              type="button"
              class="flow-invoice-filter-clear"
              (click)="resetPeriod()"
              i18n-aria-label
              aria-label="Effacer la période"
            >
              ×
            </button>
          }
        </div>

        <div class="flow-invoice-filter flow-invoice-filter-date">
          <i class="bi bi-calendar3 flow-invoice-filter-calendar"></i>
          <input
            type="date"
            class="form-control lty-form-control flow-invoice-filter-input flow-invoice-date-input"
            [class.is-empty]="!billingDateFilter.value"
            [formControl]="billingDateFilter"
          />
          @if (!billingDateFilter.value) {
            <span class="flow-invoice-date-placeholder" i18n>Date facture</span>
          }
        </div>
      </div>
    </div>

    @if (groups().length) {
      @for (group of groups(); track group.flowId) {
        <app-flow-invoices-table
          class="d-block mt-12"
          [rows]="group.items"
          [context]="gridContext"
        />
      }
    } @else {
      <div class="mt-16 text-muted text-center" i18n>
        Aucune facture à afficher
      </div>
    }
  </div>
</app-expansion-panel>
